import { RefsixState } from "../models/refsixState";
import { USER_LOGGED_IN } from "../actions/types";
import { Middleware } from "redux";
import { destroyDatabaseService, startDatabase } from "../../services/matchService";

export const startDatabaseMiddleware: Middleware<{}, RefsixState> =
    (store) => (next) => async (action) => {
        let shouldStart = false;
        let newLogin = false;

        // Get old user ID before the action updates state
        const oldUserId = store.getState().auth.session?.user_id;

        // check if any matches need updating
        switch (action.type) {
            case USER_LOGGED_IN:
                const currentAuth = store.getState().auth.session;

                newLogin = action.session && !currentAuth;
                shouldStart = true;

                break;

            case "persist/REHYDRATE":
                newLogin = !!action.session;
                shouldStart = true;
                break;
        }

        next(action);

        if (shouldStart) {
            // Get new user ID after state update
            const newUserId = store.getState().auth.session?.user_id;

            // If user has changed, destroy the old database first
            if (oldUserId && newUserId && oldUserId !== newUserId) {
                console.log(`User changed from ${oldUserId} to ${newUserId}, destroying old database`);
                await destroyDatabaseService();
                newLogin = true; // Force new login flow since we destroyed the DB
            }

            startDatabase(newLogin);
        }
    };
